import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy, NgZone, ViewChildren, ElementRef } from '@angular/core';
import { TokboxService } from './tokbox.service';
import * as OT from '@opentok/client';
import { UserService } from 'src/app/user/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { PublisherComponent } from '../publisher/publisher.component';
import { Role } from 'src/app/common';
import { NotifierService } from 'angular-notifier';
import { PatientService } from 'src/app/patient/patient.service';
import { ApportisHubService } from 'src/app/apportis.hub.service';
import { HttpErrorResponse } from '@angular/common/http';
import { TranslateOrgSpecificPipe } from 'src/app/common/pipes/translate-org-specific.pipe';
import { WaitingRoomService } from 'src/app/waiting-room/waiting-room.service';
import { MsgBoxComponent } from 'src/app/common/msg-box';
import { Constants } from 'src/app/app.constants';
import { timer } from 'rxjs';
import { Title } from '@angular/platform-browser';
const initLayoutContainer = require('opentok-layout-js');
const options = {
    maxRatio: 3 / 2,             // The narrowest ratio that will be used (default 2x3)
    minRatio: 9 / 16,            // The widest ratio that will be used (default 16x9)
    fixedRatio: false,
    // If this is true then the aspect ratio of the video is maintained and minRatio and maxRatio are ignored (default false)
    alignItems: 'center',
    // Can be 'start', 'center' or 'end'. Determines where to place items when on a row or column that is not full
    bigClass: 'OT_big',        // The class to add to elements that should be sized bigger
    bigPercentage: 0.8,       // The maximum percentage of space the big ones should take up
    bigFixedRatio: false,      // fixedRatio for the big ones
    bigAlignItems: 'center',   // How to align the big items
    smallAlignItems: 'center', // How to align the small row or column of items if there is a big one
    maxWidth: Infinity,        // The maximum width of the elements
    maxHeight: Infinity,       // The maximum height of the elements
    smallMaxWidth: Infinity,   // The maximum width of the small elements
    smallMaxHeight: Infinity,  // The maximum height of the small elements
    bigMaxWidth: Infinity,     // The maximum width of the big elements
    bigMaxHeight: Infinity,    // The maximum height of the big elements
    bigMaxRatio: 3 / 2,          // The narrowest ratio to use for the big elements (default 2x3)
    bigMinRatio: 9 / 16,         // The widest ratio to use for the big elements (default 16x9)
    bigFirst: true,            // Whether to place the big one in the top left (true) or bottom right (false).
    // You can also pass 'column' or 'row' to change whether big is first when you are in a row (bottom) or a column (right) layout
    animate: true,              // Whether you want to animate the transitions
    window: window,
    // Lets you pass in your own window object which should be the same window that the element is in
    ignoreClass: 'OT_ignore',
    // Elements with this class will be ignored and not positioned. This lets you do things like picture-in-picture
};
@Component({
    selector: 'app-tokbox',
    templateUrl: './tokbox.component.html',
    providers: [TokboxService, PatientService, TranslateOrgSpecificPipe]

})
export class TokboxComponent implements OnInit, OnDestroy {
    public session: OT.Session;
    public streams: Array<OT.Stream> = [];
    public videoStream: OT.Stream;
    public audioStream: OT.Stream;
    public subscribers: Array<any> = [];
    public subscriber: OT.Subscriber;
    secretCode: any;
    invitation = false;
    public name: string;
    public session_id: string;
    public tokenId: string;
    public s_id: number;
    // publisher: OT.Publisher;
    @ViewChild('publisher') publisher: PublisherComponent;
    @ViewChild('msgbox') msgbox: MsgBoxComponent;
    // @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
    layout;
    localStream: OT.Stream;
    isPatient = false;
    isAnonymous = false;
    clTimeout;
    VideoCallCloseConfirm = false;
    clinicainId = 0;
    waitingRoomId = 0;
    meetingdisconnected = false;
    isAudioOnly = false;
    enableWaitingSign = true;
    isRefreshed = false;
    isTimer: any;
    counterDate: any;
    role_sw_or_cli: string;
    constructor(private changeDetectorRef: ChangeDetectorRef
        , private tokboxService: TokboxService
        , private userService: UserService
        , private router: Router
        , private notifier: NotifierService
        , private ngZone: NgZone
        , private route: ActivatedRoute
        , private patientService: PatientService
        , private apportisHubService: ApportisHubService
        , private orgSpecific: TranslateOrgSpecificPipe
        , private waitingRoomService: WaitingRoomService
        , private titleService: Title,
    ) {
    }

    ngOnInit() {
        // set title
        this.titleService.setTitle(this.orgSpecific.transform('Video') + ' | ' + this.orgSpecific.transform('PageTitle'));
        const _this = this;
        this.route.params.subscribe(params => {
            if (params['sessionId']) {
                this.session_id = params['sessionId'];
                // timeout for unable to connect the user
                this.isTimer = timer(75000);
                this.isTimer.subscribe(x => {
                    if (this.enableWaitingSign) {
                        _this.notifier.notify('error', 'Your call has dropped, please make sure you have an internet connection and try again!');
                        if (this.publisher) {
                            this.publisher.sessionDisconnect();
                        }
                        setTimeout(() => {
                            window.location.replace('/app/dashboard/patient');
                        }, 3000);
                    }
                });
                /// Update user status
                this.userService.updateUserConnection().subscribe((info: any) => {
                });

                if (params['waitingroomId'] != 'undefined' && params['waitingroomId'] != undefined) {
                    this.waitingRoomId = params['waitingroomId'];
                }
                if (params['s_id'] != 'undefined' && params['s_id'] != undefined) {
                    this.s_id = params['s_id'];
                    // set db sessionId into
                    this.userService.setSessionStorageItem(this.s_id.toString(), 'SessionId');
                }
                /// get secretcode
                if (this.apportisHubService.isConnected) {
                    this.apportisHubService.connection.on('helpNowSecretCode', (code: any) => {
                        this.secretCode = code;
                    });
                }
                if (params['name'] != 'undefined' && params['name'] != undefined) {
                    this.name = params['name'];
                } else {
                    this.name = '';
                }
                if (params['clinicianId'] != 'undefined' && params['clinicianId'] != undefined) {
                    this.clinicainId = params['clinicianId'];
                    this.userService.getRolenameByUserId(this.clinicainId).subscribe(
                        (info: any) => {
                            this.role_sw_or_cli = info[0];
                            this.initialize(params['invitation'], params['token'], params['sessionId'], this.role_sw_or_cli);

                        });
                } else {
                    this.initialize(params['invitation'], params['token'], params['sessionId'], Constants.Clinician);
                }
            } else {
                window.location.replace('/app/dashboard/patient');
            }
        });
        // window resize
        let resizeTimeout;
        window.onresize = function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                if (_this.layout != undefined) {
                    _this.layout();
                }
            }, 20);
        };
    }

    initialize(invitation, token, sessionId, roleName) {
        const _this = this;
        if (invitation != undefined && invitation) {
            // connected to signlar for invited user
            if (!this.apportisHubService.isConnected) {
                this.apportisHubService.iniitializeHub(false);
            }
            if (token != undefined && token) {
                this.tokenId = token;
                this.patientService.validatetoken(token).subscribe(data => {
                    this.invitation = true;
                    this.isPatient = false;
                    this.isAnonymous = false;
                    let connected: any;
                    connected = this.apportisHubService.connected.subscribe((status) => {
                        if (status && this.apportisHubService.connection) {
                            if (this.apportisHubService.connection && this.apportisHubService.isConnected) {
                                this.apportisHubService.sendMessage('GetConnectionId');
                                this.apportisHubService.connection.on('ConnectionId', (id) => {
                                    this.apportisHubService.connection.off('ConnectionId');
                                    this.patientService.updateInvitation(id, token).subscribe(dat => {
                                        // notify for meeting disconnecting
                                        this.apportisHubService.connection.on('MeetingDisconnect', (objResult: any, host: any) => {
                                            this.apportisHubService.connection.off('MeetingDisconnect');
                                            if (objResult) {
                                                if (roleName == Role.SocialWorker) {
                                                    this.notifier.notify('error', 'Call is completed by the '
                                                     + this.orgSpecific.transform(Role.SocialWorker) + ' ');
                                                } else {
                                                    this.notifier.notify('error', 'Call is completed by the '
                                                     + this.orgSpecific.transform(host) + ' ');
                                                }
                                                this.ConfirmClose();
                                            }
                                        });
                                    });
                                });
                                this.apportisHubService.connection.on('BrowserClose', (objResult: any) => {
                                    this.apportisHubService.connection.off('BrowserClose');
                                    if (objResult) {
                                        if (roleName == Role.SocialWorker) {
                                            this.notifier.notify('error', this.orgSpecific.transform('SocialWorkerBrowserCloseMessage'));
                                        } else {
                                            this.notifier.notify('error', this.orgSpecific.transform('ClinicianBrowserCloseMessage'));
                                        }
                                    }
                                });
                            }
                        }
                    });
                },
                    (err: HttpErrorResponse) => {
                        this.publisher.sessionDisconnect();
                        window.location.replace('/error');
                    }
                );
            } else {
                this.publisher.sessionDisconnect();
                window.location.replace('/error');
            }
        } else {
            if (this.userService.CurrentUser) {
                if ((this.userService.CurrentUser.roles.indexOf(Role.CaseManager) > -1) ||
                 (this.userService.CurrentUser.roles.indexOf(Role.Clinician) > -1)) {
                } else if ((this.userService.CurrentUser.roles.indexOf(Role.Patient) > -1) ||
                 (this.userService.CurrentUser.roles.indexOf(Role.Participants) > -1)) {
                    this.isPatient = true;
                }
            } else {
                this.isAnonymous = true;
            }
        }
        if (this.apportisHubService.isConnected) {
            this.apportisHubService.connection.on('SessionCode', (code: any, clinicianId: any) => {
                this.s_id = code;
                // set db sessionId into
                this.userService.setSessionStorageItem(this.s_id.toString(), 'SessionId');
                this.clinicainId = clinicianId;
            });
        }
        /// clinician snooze the call
        if (this.apportisHubService.isConnected) {
            this.apportisHubService.connection.on('clinicianSnoozeAppointment', (obj: any) => {
                this.apportisHubService.connection.off('clinicianSnoozeAppointment');
                this.isRefreshed = true;
                if (obj) {
                    if (this.s_id > 0) {
                        this.userService.setSessionStorageItem('0', 'SessionId');
                    }
                    if (roleName == Role.SocialWorker) {
                        this.notifier.notify('error', this.orgSpecific.transform('SocialWorkerSnoozedTheCall'));
                    } else {
                        this.notifier.notify('error', this.orgSpecific.transform('ClinicianSnoozedTheCall'));
                    }
                    if (this.publisher) {
                        this.publisher.sessionDisconnect();
                    }
                    setTimeout(() => {
                        window.location.replace('/app/dashboard/patient');
                    }, 3000);
                }
            });
            this.apportisHubService.connection.on('MeetingDisconnect', (objResult: any, host: any) => {
                this.apportisHubService.connection.off('MeetingDisconnect');
                if (objResult) {
                    this.meetingdisconnected = true;
                    this.isRefreshed = true;
                    if (roleName == Role.SocialWorker) {
                        this.notifier.notify('error', 'Call is completed by the ' + this.orgSpecific.transform(Role.SocialWorker));
                    } else {
                        this.notifier.notify('error', 'Call is completed by the ' + this.orgSpecific.transform(host));
                    }
                    this.ConfirmClose();
                }
            });
            this.apportisHubService.connection.on('BrowserClose', (objResult: any) => {
                this.apportisHubService.connection.off('BrowserClose');
                if (objResult && !this.isRefreshed) {
                    if (roleName == Role.SocialWorker) {
                        this.notifier.notify('error', this.orgSpecific.transform('SocialWorkerBrowserCloseMessage'));
                    } else {
                        this.notifier.notify('error', this.orgSpecific.transform('ClinicianBrowserCloseMessage'));
                    }
                }
            });
            this.apportisHubService.connection.on('NoResponse', (objResult: any, isAppointment: any) => {
                this.apportisHubService.connection.off('NoResponse');
                this.isRefreshed = true;
                if (objResult) {
                    if (this.s_id > 0) {
                        this.userService.setSessionStorageItem('0', 'SessionId');
                    }
                    if (roleName == Role.SocialWorker) {
                        this.notifier.notify('error', this.orgSpecific.transform('SocialWorkerNotResponseMsg'));
                    } else {
                        this.notifier.notify('error', this.orgSpecific.transform('ClinicianNotResponseMsg'));
                    }
                    if (this.publisher) {
                        this.publisher.sessionDisconnect();
                    }
                    setTimeout(() => {
                        window.location.replace('/app/dashboard/patient');
                    }, 3000);
                }
            });
        }
        this.tokboxService.getToken(sessionId).subscribe((info: any) => {
            this.tokboxService.initSession(info.token).then((session: OT.Session) => {
                this.session = session;
                this.session.on('streamCreated', (event) => {
                    if (this.invitation) {
                        if (token != undefined && token) {
                            this.tokenId = token;
                            this.patientService.validatetoken(token).subscribe(data => {
                                this.invitation = true;
                                this.isPatient = false;
                                this.isAnonymous = false;
                            },
                                (err: HttpErrorResponse) => {
                                    window.location.replace('/error');
                                }
                            );
                        } else {
                            window.location.replace('/error');
                        }
                    }
                    this.enableWaitingSign = false;
                    this.streams.push(event.stream);
                    this.localStream = event.stream;
                    // set the layout
                    const layoutContainer = document.getElementById('layoutContainer');
                    // Initialize the layout container and get a reference to the layout method
                    this.layout = initLayoutContainer(layoutContainer, options).layout;
                    this.subscriber = this.session.subscribe(event.stream,
                        layoutContainer, {
                        insertMode: 'append'
                    }, (err) => {
                        if (err) {
                            console.log(err.message);
                            //  alert(err.message);
                        }
                    });
                    this.layout();
                    if (!this.changeDetectorRef['destroyed']) {
                        this.changeDetectorRef.detectChanges();
                    }
                });
                // this.session.on("sessionDisconnected", (event) => {
                //     _this.publisher.disconnect();
                //     setTimeout(() => {
                //         _this.redirect();
                //     }, 3000);
                // });
                this.session.on({
                    sessionReconnecting: function (event) {
                        _this.notifier.notify('error', 'Your internet connection is too slow! Attempting to reconnect automatically');
                    },
                    sessionReconnected: function (event) {
                        _this.notifier.notify('success', 'Reconnected to the session');
                    },
                });
                this.session.on('streamDestroyed', (event) => {
                    if (event.reason === 'networkDisconnected') {
                        _this.notifier.notify('error', 'User lost their internet connection,please stay on the same window until they rejoin, or disconnect the call');
                    }
                    _this.flexlayout();
                });
                // this.session.on('sessionConnected', () => {
                //     this.publisher.publish()
                // });
            })
                .then(() => this.tokboxService.connect().then(() => {
                    if (this.session['isConnected']()) {
                        this.publisher.publish();
                    }
                    // this.enableWaitingSign=true;
                }))
                .catch((err) => {
                    this.notifier.notify('error', this.orgSpecific.transform('UnableConnectContactAdministrator'));
                });
        });
    }

    ngOnDestroy(): void {
        // this.session = null;
        this.changeDetectorRef.detach();
    }

    public closeVideo() {
        this.VideoCallCloseConfirm = true;
    }

    private redirect() {
        if (this.userService.CurrentUser) {
            if ((this.userService.CurrentUser.roles.indexOf(Role.Clinician) > -1) ||
             (this.userService.CurrentUser.roles.indexOf(Role.CaseManager) > -1)) {
                if (this.userService.appointmentId) {
                    this.router.navigate(['/app/appointment/complete', this.userService.appointmentId, 0]);
                } else {
                    window.location.replace('/app/dashboard/patient');
                }
            } else {
                window.location.replace('/app/dashboard/patient');
            }
        } else {
            window.location.replace('/signin');
        }
    }

    flexlayout() {
        const _this = this;
        /// window.dispatchEvent(new Event('resize'));
        clearTimeout(_this.clTimeout);
        _this.clTimeout = setTimeout(function () {
            if (_this.layout != undefined) {
                _this.layout();
                if (!_this.changeDetectorRef['destroyed']) {
                    _this.changeDetectorRef.detectChanges();
                }
            }
        }, 1000);
    }

    cancelCloseVideo() {
        this.VideoCallCloseConfirm = false;
    }

    ConfirmClose() {
        this.VideoCallCloseConfirm = false;
        const _this = this;
        if (this.invitation) {
            this.patientService.updateInviteUserSessiontoExpired(this.tokenId).subscribe((info: any) => {
            });
            this.disconnect();
        } else if (this.isPatient) {
            if (this.s_id > 0) {
                this.updateDetails();
            } else {
                this.waitingRoomService.getDbSessionId(this.waitingRoomId, this.userService.appointmentId > 0 ?
                     this.userService.appointmentId : 0).then((info: any) => {
                    if (info > 0) {
                        this.s_id = info;
                        // set db sessionId into
                        this.userService.setSessionStorageItem(this.s_id.toString(), 'SessionId');
                        this.updateDetails();
                    } else {
                        if (!this.meetingdisconnected) {
                            this.patientService.clientDisconnected(this.clinicainId, this.s_id).subscribe((inf: any) => {
                            });
                        }
                        this.disconnect();
                    }
                });
            }
        } else {
            if (this.s_id > 0) {
                if (!this.meetingdisconnected && !this.invitation) {
                    this.patientService.clientDisconnected(this.clinicainId, this.s_id).subscribe((info: any) => {
                    });
                }
            }
            this.disconnect();
        }
    }

    disconnect() {
        if (this.publisher) {
            this.publisher.sessionDisconnect();
        }
        if (!this.changeDetectorRef['destroyed']) {
            this.changeDetectorRef.detectChanges();
        }
        setTimeout(() => {
            if (this.isAnonymous || this.invitation) {
                // getting connectionId
                const signlRurl = (this.apportisHubService.connection as any).connection.transport.webSocket.url;
                let connectionId: any;
                connectionId = this.apportisHubService.getParameterByName('id', signlRurl);
                this.apportisHubService.closeConenction(connectionId);
            }
            this.redirect();
        }, 3000);
    }

    updateDetails() {
        this.patientService.updateUserSessiontoExpired(this.s_id).subscribe((info: any) => {
        });
        if (!this.meetingdisconnected) {
            this.patientService.clientDisconnected(this.clinicainId, this.s_id).subscribe((info: any) => {
            });
        }
        if (this.waitingRoomId > 0 && this.s_id > 0) {
            this.waitingRoomService.UpdateEndTime(this.waitingRoomId).subscribe((info: any) => {
            });
        }
        this.disconnect();
    }

    public audio() {
        this.publisher.audio();
        // this.subscriber.subscribeToVideo(false);
        this.isAudioOnly = true;
    }

    public video() {
        this.publisher.video();
        // this.subscriber.subscribeToVideo(true);
        this.isAudioOnly = false;
    }
}

